import { GetMultiRole } from "../../../../Components/Utils/roles";
import Buyer from "./Components/Buyer";
import CostSavingByOrdersProDash from "./Components/CostSavingByOrders";
import CostSavingByProcurmentTeamProdash from "./Components/CostSavingByProcurmentTeam";
import MonthWiseProcurment from "./Components/MonthWiseProcurment";
import OrdersByRegionProDash from "./Components/OrdersByRegion";
import OrdersRecordProDash from "./Components/OrdersRecord";
import POToSuppliersProDash from "./Components/POToSuppliers";
import PurchaseOrderToSupplierProcuDash from "./Components/PurchaseOrderToSupplier";
import QuotesSubTotalProcuDash from "./Components/QuotesSubTotal";
import QuotesSubmittedByProcurmentTeamProDash from "./Components/QuotesSubmittedByProcurmentTeam";
import RequestFromCustomerProcuDash from "./Components/RequestFromCustomer";
import SuppliersProcuDash from "./Components/SuppliersProcuDash";
import SuppliersWithLeastLeadTimeProDash from "./Components/SuppliersWithLeastLeadTime";

function ProcurmentDashboard() {
  return (
    <div className="w-full space-y-4 pb-6">
      {/* Top KPI Stat Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        <SuppliersProcuDash />
        <RequestFromCustomerProcuDash />
        <QuotesSubTotalProcuDash />
        <PurchaseOrderToSupplierProcuDash />
      </div>

      {/* Main Trends: PO Approvals & YPR Assigned */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <POToSuppliersProDash />
        <MonthWiseProcurment />
      </div>

      {/* Buyer Performance & Quotes Submitted */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Buyer />
        <QuotesSubmittedByProcurmentTeamProDash />
      </div>

      {/* Order Records & Regional Orders */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <OrdersRecordProDash />
        <OrdersByRegionProDash />
      </div>

      {/* Cost Savings: By Orders & By Team */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <CostSavingByOrdersProDash />
        <CostSavingByProcurmentTeamProdash />
      </div>

      {/* Supplier Lead Time Insights */}
      {GetMultiRole([
        "admin",
        "super admin",
        "management",
        "manager",
        "coordinator",
      ]) && (
        <div className="grid grid-cols-1 gap-4">
          <SuppliersWithLeastLeadTimeProDash />
        </div>
      )}
    </div>
  );
}

export default ProcurmentDashboard;
